import React from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import Cover from '../../components/Cover/Cover';
import ListSection from '../../components/ListSections/ListSections';
import ListProduct from '../../components/ListProducts/ListProduct';
import Footer from '../../components/Footer';
import Splash from '../../components/Splash';
import CoverOverlay from '../../components/CoverOverlay';
import BottomCart from '../../components/BottomCart';
import InfoBar from '../../components/InfoBar';
import {
  updateShop,
  selectSection,
  setNavbarHeight,
  setIsMobile,
  showHorizontalSection,
  showAddressModal,
  showMessageModal,
  updateShopIsLoaded
} from '../../redux/actions';
import {
  getOffsetTop,
  isTerminal,
  resetTerminalTimeout,
  isTerminalVertical,
  isStringNotNull,
  getClosedMessage,
  isSplash,
  isProductDisabled,
  isObjectNotNull
} from '../../utils';
import { loadLocalizeSdk } from '../../api';
import {
  getClasses,
  displayOrNotHeader,
  resetCartIfNeeded,
  updateShopFromLink
} from './Home.services';
import { BLOCK_CONTENT, ORDER_TYPE_DELIVERY } from '../../constants';

const INITIAL_STATE = {
  displaySectionsNavBar: false
};

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = INITIAL_STATE;
  }

  componentWillMount() {
    const { customerAddress } = this.props;
    updateShopFromLink(this, customerAddress);
  }

  componentDidMount() {
    loadLocalizeSdk();
    const { setIsMobile, showHorizontalSection } = this.props;
    setIsMobile(window.matchMedia('screen and (max-width: 575px)').matches);
    if (!isTerminalVertical()) {
      window.addEventListener('scroll', this.handleScroll);
    }
    window.addEventListener('resize', this.updateDimensions);
    showHorizontalSection();
  }

  componentWillReceiveProps(nextProps) {
    const {
      sectionOrientation,
      showHorizontalSection,
      showAddressModal,
      customerAddress: prevCustomerAddress,
      isUserAnonymous,
      showMessageModal,
      shopIsLoaded,
      updateShopIsLoaded,
      marketplace,
      history,
      match,
      shops
    } = this.props;
    const { networkFees = {} } = nextProps;
    const { delivery = {} } = networkFees;
    const { productFees } = delivery;
    updateShopFromLink(this, nextProps.customerAddress);
    const marketplaceEnabled = marketplace && marketplace.enabled;
    let check = false;
    const { orderType } = nextProps.customerAddress || {};
    const { orderType: prevOrderType } = prevCustomerAddress || {};
    check =
      !_.isEqual(orderType, prevOrderType) &&
      (_.isEqual(orderType, ORDER_TYPE_DELIVERY) || _.isEqual(prevOrderType, ORDER_TYPE_DELIVERY));

    const needToResetCart = _.find(nextProps.cart, product => {
      return product.shopId !== nextProps.shopId || isProductDisabled(product);
    });
    if (needToResetCart || (productFees && check && isObjectNotNull(nextProps.cart))) {
      resetCartIfNeeded();
    }

    if (sectionOrientation !== nextProps.sectionOrientation && !isTerminalVertical()) {
      showHorizontalSection();
    }
    // Check if shopId in url exists
    let shopExists = true;
    if (marketplaceEnabled && match.params.shopId) {
      shopExists = _.find(shops, (shop, shopIndex) => {
        return shopIndex === match.params.shopId;
      });
    }
    if (
      nextProps.overlayCover !== BLOCK_CONTENT &&
      !nextProps.customerAddress &&
      nextProps.googleMapsEnabled &&
      nextProps.addressIsLoaded &&
      !isUserAnonymous &&
      !this.executed &&
      !isSplash() &&
      !nextProps.connexionModal
    ) {
      this.executed = true;
      if (marketplaceEnabled && !shopExists) {
        history.push('/');
      } else {
        showAddressModal(true);
      }
    } else if (!nextProps.addressIsLoaded || nextProps.customerAddress) {
      showAddressModal(false);
    }

    // When user does not have an address, force to show error modal
    if (!nextProps.customerAddress && nextProps.addressIsLoaded && !nextProps.shopIsLoaded) {
      updateShopIsLoaded(true);
    }

    if (
      !shopIsLoaded &&
      nextProps.shopIsLoaded &&
      nextProps.customerAddress &&
      isStringNotNull(nextProps.closed) &&
      !isTerminal()
    ) {
      showMessageModal(getClosedMessage(nextProps.closed));
    }
  }

  updateDimensions = () => {
    const { setIsMobile, setNavbarHeight, showHorizontalSection } = this.props;
    setIsMobile(window.matchMedia('screen and (max-width: 575px)').matches);
    setNavbarHeight();
    if (!isTerminalVertical()) {
      showHorizontalSection();
    }
  };

  handleScroll = () => {
    const { sectionsRef, selectSection, setNavbarHeight, navbarHeight } = this.props;
    const { displaySectionsNavBar } = this.state;
    const extraTop = 2;
    const needToDisplaySectionsNavBar =
      this.listSections && window.scrollY >= this.listSections.offsetTop - extraTop;
    if (needToDisplaySectionsNavBar && !displaySectionsNavBar) {
      this.setState({ displaySectionsNavBar: true });
    } else if (!needToDisplaySectionsNavBar && displaySectionsNavBar) {
      this.setState({ displaySectionsNavBar: false });
    }
    setNavbarHeight();

    let offsetTop = 0;
    let newSectionKey = null;
    const isBottomPage = window.innerHeight + window.scrollY >= document.body.offsetHeight;
    _.map(sectionsRef, (sectionRef, sectionKey) => {
      if (
        sectionRef &&
        (window.scrollY >= getOffsetTop(sectionRef) - parseInt(navbarHeight, 10) - extraTop ||
          isBottomPage) &&
        getOffsetTop(sectionRef) > offsetTop
      ) {
        offsetTop = getOffsetTop(sectionRef);
        newSectionKey = sectionKey;
      }
    });

    if (newSectionKey) {
      selectSection(newSectionKey);
    }
  };

  onTouchStart = () => {
    document.body.style.overflow = 'hidden';
  };

  onTouchEnd = () => {
    document.body.style.overflow = 'visible';
  };

  renderCloseBar = () => {
    const { closed, shopUnavailable } = this.props;
    const isShopClosed = closed || shopUnavailable;
    if (isStringNotNull(isShopClosed)) {
      return (
        <div className='row'>
          <div className='col text-center'>
            <div className='alert alert-danger mb-0' role='alert'>
              {getClosedMessage(isShopClosed)}
            </div>
          </div>
        </div>
      );
    }
  };

  render() {
    const {
      splash,
      navbarHeight,
      isUserAnonymous,
      overlayCover,
      setNavbarHeight,
      isHorizontalSection,
      shopIsLoaded,
      marketplace
    } = this.props;
    const { listSectionClass, listProductClass } = getClasses();
    const { displaySectionsNavBar } = this.state;
    const displayNavBar = isHorizontalSection && (displaySectionsNavBar || isUserAnonymous);
    displayOrNotHeader(displaySectionsNavBar || isUserAnonymous);
    const marketplaceEnabled = marketplace && marketplace.enabled;
    const displayOverlay = (overlayCover && isTerminal()) || overlayCover === BLOCK_CONTENT;
    let terminalMarginBottom = 0;
    if (document.getElementById('bottom-cart')) {
      terminalMarginBottom = document.getElementById('bottom-cart').scrollHeight;
    }
    const showSplash = isSplash() || (!shopIsLoaded && marketplaceEnabled);
    return (
      <>
        {showSplash && <Splash />}
        {!showSplash && (
          <>
            {displayOverlay && <CoverOverlay />}
            {!displayOverlay && (
              <div
                onClick={() => {
                  if (isTerminal()) {
                    resetTerminalTimeout();
                  }
                }}
                style={{ marginBottom: terminalMarginBottom }}
              >
                <div id='top' style={{ position: 'absolute', top: '0px', left: '0px' }} />
                {(!isUserAnonymous || isTerminalVertical()) && (
                  <div
                    ref={el => {
                      setNavbarHeight();
                    }}
                  >
                    <Cover />
                  </div>
                )}
                <div className='container-fluid px-0' id='main-container'>
                  {!isHorizontalSection && !isTerminalVertical() && (
                    <div
                      ref={el => {
                        this.listSections = el;
                        setNavbarHeight();
                      }}
                    >
                      <div
                        id='info-bar'
                        className={`shadow ${
                          displaySectionsNavBar || isUserAnonymous ? 'fixed-top' : ''
                        }`}
                      >
                        {shopIsLoaded && this.renderCloseBar()}
                        <InfoBar />
                      </div>
                    </div>
                  )}
                  {isHorizontalSection && (
                    <div
                      ref={el => {
                        this.listSections = el;
                        setNavbarHeight();
                      }}
                    >
                      <div
                        id='info-bar'
                        className={`shadow ${displayNavBar ? 'fixed-top' : ''}`}
                        onTouchStart={this.onTouchStart}
                        onTouchEnd={this.onTouchEnd}
                      >
                        {shopIsLoaded && this.renderCloseBar()}
                        <InfoBar />
                        <ListSection />
                      </div>
                    </div>
                  )}
                  <div className={`col-12 ${!isTerminalVertical() ? 'px-0 px-sm-5' : 'pl-3 pr-4'}`}>
                    <div className={`row ${!isTerminalVertical() && 'px-3 px-sm-0 px-md-3'}`}>
                      {!isHorizontalSection && (
                        <div
                          className={listSectionClass}
                          style={{
                            marginTop:
                              displaySectionsNavBar || isUserAnonymous ? navbarHeight : '16px'
                          }}
                        >
                          <ListSection />
                        </div>
                      )}
                      <div
                        className={listProductClass}
                        style={{
                          marginTop:
                            displaySectionsNavBar || isUserAnonymous ? navbarHeight : '16px'
                        }}
                      >
                        <ListProduct />
                      </div>
                    </div>
                  </div>
                </div>
                {!isTerminal() && <Footer />}
                {isTerminalVertical() && <BottomCart />}
              </div>
            )}
          </>
        )}
      </>
    );
  }
}

const mapStateToProps = ({
  componentReducer,
  sectionReducer,
  userReducer,
  cartReducer,
  shopReducer,
  configurationReducer,
  addressModal
}) => {
  const { sectionKey, sectionsRef, selectedSection } = sectionReducer;
  const { customerAddress, isUserAnonymous, addressIsLoaded, userConnected } = userReducer;
  const {
    splash,
    navbarHeight,
    isMobile,
    overlayCover,
    isHorizontalSection,
    googleMapsEnabled,
    connexionModal
  } = componentReducer;
  const {
    sectionOrientation,
    secondaryColor,
    webapp,
    marketplace,
    servicePrice = {}
  } = configurationReducer;
  const { networkFees } = servicePrice;
  const {
    shopId,
    closed,
    sections,
    showClosedShop,
    shopIsLoaded,
    shops,
    shopUnavailable
  } = shopReducer;
  return {
    selectedSection,
    secondaryColor,
    sectionKey,
    customerAddress,
    networkFees,
    splash,
    cart: cartReducer,
    shopId,
    closed,
    sectionOrientation,
    sectionsRef,
    sections,
    navbarHeight,
    isMobile,
    isUserAnonymous,
    overlayCover,
    isHorizontalSection,
    googleMapsEnabled,
    addressIsLoaded,
    userConnected,
    addressModal,
    showClosedShop,
    shopIsLoaded,
    webapp,
    marketplace,
    shops,
    shopUnavailable,
    connexionModal
  };
};

export default connect(mapStateToProps, {
  updateShop,
  selectSection,
  setIsMobile,
  setNavbarHeight,
  showHorizontalSection,
  showAddressModal,
  updateShopIsLoaded,
  showMessageModal
})(withRouter(Home));
